import { Record } from 'immutable';
export const DOMAIN_VERIFICATION_STATUS = {
  NO_DOMAIN: 'NO_DOMAIN',
  UNVERIFIED_DOMAIN: 'UNVERIFIED_DOMAIN',
  VERIFIED_DOMAIN: 'VERIFIED_DOMAIN'
};
export const LISTING_STATUS = {
  UNLISTED: 'UNLISTED',
  PUBLISHED: 'PUBLISHED',
  CERTIFIED: 'CERTIFIED'
};
const defaults = {
  clientId: '',
  appId: null,
  name: '',
  shortDescription: '',
  description: '',
  iconUrl: '',
  listingIconUrl: '',
  scopeGroups: [],
  authorized: false,
  provider: {
    certified: false,
    domain: null,
    published: false,
    verified: false
  }
};
class ApplicationAuthorization extends Record(defaults) {
  constructor(data) {
    super(Object.assign({}, data));
  }
}
export default ApplicationAuthorization;